/**
 * Google Places address suggestions for inputs marked data-places. When a place is
 * picked, its coordinates go into the inputs named by data-lat / data-lng (looked up
 * inside the closest [data-places-scope], or the form), and its country code into
 * data-country (the server takes the pickup timezone from it). Google Maps itself is loaded
 * by the layout on pages that ask for it (@section('google_places')).
 */
const OPTIONS = { types: ['geocode', 'establishment'], fields: ['place_id', 'geometry', 'formatted_address', 'name', 'address_components'] };

function countryCode(place) {
    const country = (place.address_components || []).find((c) => (c.types || []).includes('country'));
    return country ? country.short_name : '';
}

function attach(input) {
    if (input.dataset.placesReady || !window.google?.maps?.places) {
        return;
    }
    input.dataset.placesReady = '1';
    const autocomplete = new window.google.maps.places.Autocomplete(input, OPTIONS);
    autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (!place?.geometry) {
            return;
        }
        const scope = input.closest('[data-places-scope]') || input.form || document;
        const set = (selector, value) => {
            if (!selector) {
                return;
            }
            const target = scope.querySelector(selector);
            if (target) {
                target.value = value;
                target.dispatchEvent(new Event('change', { bubbles: true }));
            }
        };
        set(input.dataset.lat, place.geometry.location.lat());
        set(input.dataset.lng, place.geometry.location.lng());
        set(input.dataset.placeId, place.place_id || '');
        set(input.dataset.country, countryCode(place));
        if (place.formatted_address && !input.value.includes(',')) {
            input.value = place.name && !place.formatted_address.startsWith(place.name) ? `${place.name}, ${place.formatted_address}` : place.formatted_address;
        }
    });
    // Typing again invalidates the coordinates of the previous pick.
    input.addEventListener('input', () => {
        const scope = input.closest('[data-places-scope]') || input.form || document;
        [input.dataset.lat, input.dataset.lng, input.dataset.placeId, input.dataset.country].forEach((selector) => {
            const target = selector && scope.querySelector(selector);
            if (target) {
                target.value = '';
            }
        });
    });
}

export function attachPlaces(root = document) {
    root.querySelectorAll('input[data-places]').forEach(attach);
}

window.initGooglePlacesAutocomplete = () => attachPlaces();
document.addEventListener('google-maps-loaded', () => attachPlaces());
if (window.googleMapsLoaded) {
    attachPlaces();
}
